// extracted by mini-css-extract-plugin
export default {"arrowUIWrapperContainer":"ArrowUIWrapper_arrowUIWrapperContainer__Vw3jN","adsContainer":"ArrowUIWrapper_adsContainer__i963U"};